import { CopyrightText } from '@/components/copyright-text'
import { GUARDIAN_WEB_ENDPOINT } from '@/env'
import { handleLaunchBrowser } from '@/utils/launchBrowser'
import Image from 'next/image'

interface LoginLayoutProps {
  children: React.ReactNode
}

export const LoginLayout = (props: LoginLayoutProps): JSX.Element => {
  return (
    <main className="flex h-screen flex-col bg-white">
      <header className="border-b-bg-basic flex h-[50px] items-center border-b bg-white px-[14px] md:h-[60px] md:px-[18px] lg:h-[70px]">
        <Image
          src="/sged-logo.svg"
          width={73}
          height={28}
          className="md:h-[45px] md:w-[117px]"
          alt="Sony Global Education"
        />
      </header>
      <div className="grow">{props.children}</div>
      <footer className="mt-auto py-3">
        <div className="mb-[2px] flex justify-center text-[11px] text-secondary-text">
          <div
            className="cursor-pointer border-l border-l-secondary-text px-2"
            onClick={() =>
              handleLaunchBrowser(
                `${GUARDIAN_WEB_ENDPOINT}/web/terms-of-service/`
              )
            }
          >
            利用規約
          </div>
          <div
            className="cursor-pointer border-l border-l-secondary-text px-2"
            onClick={() =>
              handleLaunchBrowser(
                `${GUARDIAN_WEB_ENDPOINT}/web/privacy-policy/`
              )
            }
          >
            プライバシーポリシー
          </div>
          <div
            className="cursor-pointer border-l border-l-secondary-text px-2"
            onClick={() =>
              handleLaunchBrowser(
                'https://support.sonyged.com/hc/ja/requests/new'
              )
            }
          >
            お問い合わせ
          </div>
          <div
            className="cursor-pointer border-l border-r border-l-secondary-text border-r-secondary-text px-2"
            onClick={() =>
              handleLaunchBrowser(
                `${GUARDIAN_WEB_ENDPOINT}/web/cookie-regulation/`
              )
            }
          >
            外部送信一覧
          </div>
        </div>
        <p className="text-center text-xs text-[#828488]">
          <CopyrightText />
        </p>
      </footer>
    </main>
  )
}
